<template>
    <fieldset>
        <ValidationObserver ref="validationObserver" slim>
            <ValidationProvider
                v-slot="{ classes, errors }"
                ref="provider"
                :rules="form.getValidationRules(name + '.postcode')"
                :custom-messages="form.getValidationMessages(name + '.postcode')"
                :name="name + '.postcode'"
                tag="div"
                mode="eager"
                v-if="!address.meta.showAddressRollup"
            >
                <div class="digi-input w-full mb-4" :class="classes">
                    <label class="form-label font-inter font-bold text-viva-money-black" :for="name" v-html="errors[0] || 'Home postcode'"></label>
                    <div class="form-input -m-2">
                        <div class="form-input-inner p-2 w-full">
                            <div class="input-wrapper w-full relative">
                                <input
                                    :name="name + '.postcode'"
                                    type="text"
                                    maxlength="8"
                                    @blur="handleBlur"
                                    v-model="address.postcode"
                                    v-on:input="handlePostcodeInput"
                                    :disabled="address.meta.isSearching"
                                    class="textbox bg-white h-14 w-full border-black border-2 focus:border-viva-money-secondary-yellow outline-none p-4 uppercase text-base"
                                />
                                <div class="absolute right-0 top-0 bottom-0 flex">
                                    <button
                                        type="button"
                                        :disabled="address.meta.isSearching"
                                        class="viva-drop-submit-button my-2 mr-2 px-4"
                                        @click="doPostcodeSearch"
                                    >   <span class="transition-opacity duration-200 text-smaller leading-6" :class="{ 'opacity-0': address.meta.isSearching }">Find Address</span>
                                        <div class="transition-opacity duration-200 text-smaller leading-6 absolute left-0 right-0 top-0 bottom-0 flex justify-center items-center" :class="{ 'opacity-0': !address.meta.isSearching }"><img src="/img/tail-spin-white.svg" height="28" width="28"></div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationProvider>
            <digi-select
                name = "addressSelect"
                v-if="address.meta.showAddressResults"
                label="Select your address"
                :options="addressOptions"
                v-model="address.meta.selectedAddress"
                :rules="{ required: true && !this.address.meta.enterManually }"
                ref="addressSelect"
                v-on:input="handleAddressResultsChange"
                v-show="!this.address.meta.enterManually"
            ></digi-select>
            <a
                v-show="!address.meta.showAddressRollup"
                class="inline-block -mt-4 mb-4 underline text-viva-money-orange hover:text-viva-money-orange cursor-pointer text-sm leading-5 font-semibold font-inter"
                @click.prevent="setEnterManually"
            >Enter address manually</a>
            <ValidationObserver slim ref="addressFieldObserver">
                <digi-input
                    type="text"
                    label="House name/number"
                    v-model="address.house"
                    :attributes="{ maxlength: 30}"
                    v-show="address.meta.showAllFields"
                    :name="name + '.house'"
                    :rules="form.getValidationRules(name + '.house')"
                    :custom-messages="this.$getValidationMessages(name + '.house')"
                ></digi-input>
                <digi-input
                    type="text"
                    label="Street"
                    v-model="address.address1"
                    :attributes="{ maxlength: 30}"
                    v-show="address.meta.showAllFields"
                    :name="name + '.address1'"
                    :rules="form.getValidationRules(name + '.address1')"
                    :custom-messages="this.$getValidationMessages(name + '.address1')"
                ></digi-input>
                <digi-input
                    type="text"
                    label="Locality"
                    v-model="address.address2"
                    :attributes="{ maxlength: 30}"
                    v-show="address.meta.showAllFields"
                    :name="name + '.address2'"
                    :rules="form.getValidationRules(name + '.address2')"
                    :custom-messages="this.$getValidationMessages(name + '.address2')"
                ></digi-input>
                <digi-input
                    type="text"
                    label="Town"
                    v-model="address.town"
                    :attributes="{ maxlength: 30}"
                    v-show="address.meta.showAllFields"
                    :name="name + '.town'"
                    :rules="form.getValidationRules(name + '.town')"
                    :custom-messages="this.$getValidationMessages(name + '.town')"
                ></digi-input>
                <digi-input
                    type="text"
                    label="County"
                    v-model="address.county"
                    :attributes="{ maxlength: 30}"
                    v-show="address.meta.showAllFields"
                    :name="name + '.county'"
                    :rules="form.getValidationRules(name + '.county')"
                    :custom-messages="this.$getValidationMessages(name + '.county')"
                ></digi-input>
            </ValidationObserver>
            <div class="w-full mb-8" v-show="address.meta.showAddressRollup">
                <label class="form-label">Current address</label>
                <div
                    class="address-rollup bg-white flex flex-col rounded shadow-lg mb-8 border-viva-money-secondary-yellow border-2 border-solid"
                >
                    <div
                        class="flex w-full address-rollup-address p-4 text-gray-800"
                        v-html="addressFormatted"
                    ></div>
                    <div
                        class="flex w-full flex-row address-rollup-buttons border-t border-0 border-gray-500 border-solid"
                    >
                        <button
                            type="button"
                            class="text-gray-800 p-4 flex address-rollup-replace border-0 border-r border-gray-500 border-solid justify-center w-1/2 bg-transparent"
                            @click="address.meta.showAddressRollup = false; address.meta.showAddressResults = false; address.meta.addressses = {}; address.postcode = null;"
                        >Replace address</button>
                        <button
                            type="button"
                            class="text-gray-800 p-4 flex address-rollup-edit justify-center w-1/2 bg-transparent"
                            @click="editAddress"
                        >Edit address</button>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </fieldset>
</template>
 
<script>
import DigiInput from "./digi-input";
import DigiSelect from "./digi-select";
import { validate } from "vee-validate";
import { trim } from "underscore.string";
import { isObject, clone } from "underscore";
import { merge } from "lodash";
import pMinDelay from 'p-min-delay';

const axios = require("axios").default;

export default {
    inject: [ '$getValidationRules', '$getValidationMessages', '$globals', '$customer'],
    created() {
        if (this.value && isObject(this.value)) {
            let merged = merge(this.address, this.value);
            this.address = merged;
        }
    },
    watch: {
        'address': {
            handler() {
                this.$emit("change", this.address);
                this.$emit("input", this.address);
            },
            deep: true
        }
    },
    data: function() {
        return {
            address: {
                postcode: "",
                house: "",
                address1: "",
                address2: "",
                town: "",
                county: "",
                meta: {
                    isSearching: false,
                    showAddressResults: false,
                    addresses: {},
                    selectedAddress: "",
                    enterManually: false,
                    showAllFields: false,
                    showAddressRollup: false,
                }
            }
        };
    },
    computed: {
        addressFormatted() {
            return (
                [
                    this.address.house,
                    this.address.address1,
                    this.address.address2,
                    this.address.town,
                    this.address.county,
                    this.address.postcode
                ]
                    .filter(Boolean)
                    .join(", ")
                    // Standardize commas and spaces
                    .replace(/,\s*/gi, ", ")
                // .replace(/,\s*,/gi, ",");
            );
        },
        addressOptions() {
            if (this.address.meta.addresses && this.address.meta.addresses.length > 0) {
                let options = {};
                options[0] = "Please select your address";
                for (let [key, value] of Object.entries(this.address.meta.addresses)) {
                    key++;
                    options[key] = value.formatted_address
                        .filter(Boolean)
                        .join(", ")
                        // Standardize commas and spaces
                        .replace(/,\s*/gi, ", ");
                    // .replace(/,\s*,/gi, ",");
                }
                return options;
            } else {
                return {};
            }
        }
    },
    props: {
        form: {},
        name: {
            default: ""
        },
        value: Object
    },
    methods: {
        editAddress() {
            this.address.meta.showAddressRollup = false; 
            this.address.meta.showAllFields = true
            this.$nextTick(() => {
                this.$refs.addressFieldObserver.validate();
            });
        },
        setEnterManually(e) {
            this.address.meta.isSearching = false;
            this.address.meta.enterManually = true;
            this.address.meta.showAllFields = true;
            window.amplitude.postcodeLookupEvent();
        },
        handleAddressResultsChange(e) {
            if (e > 0) {
                let address = this.address.meta.addresses[e - 1];

                if (address.sub_building_name) {
                    this.address.house = address.line_1;
                    this.address.address1 = address.line_2;
                } else {
                    this.address.house = trim(
                        [address.building_number, address.building_name].join(", "),
                        [",", " "]
                    );
                    this.address.address1 = address.thoroughfare;
                }
                
                this.address.address2 = address.locality || address.district;
                // this.address.address2 = address.locality;
                this.address.town = address.town_or_city;
                this.address.county = (address.county || address.town_or_city);
                this.address.meta.showAddressResults = false;
                this.address.meta.showAddressRollup = true;
                this.address.meta.showAllFields = false;
                this.address.meta.addresses = {};
                this.address.meta.selectedAddress = 0;
                this.$emit("change", this.address);
                this.$emit("input", this.address);
                this.$nextTick(() => {
                    this.$refs.addressFieldObserver.validate({ silent: true})
                        .then((result) => {
                            if (!result) {
                                this.editAddress();
                            }
                        });
                });
            }
        },
        handlePostcodeInput(e) {
            this.$set(this.address, "postcode", e.target.value.toUpperCase().trim());
            if (!this.address.meta.enterManually) {
                this.doPostcodeSearch();
            }
        },
        handleBlur(e) {
            if (this.value === null) {
                window.amplitude.postcodeInputInteractionEvent(this.name, 'User has left the field blank');
            }
            if (this.value !== null) {
                setTimeout(() => {
                    window.amplitude.postcodeInputInteractionEvent(this.name, this.$refs.provider.flags.valid === true ? 'valid' : 'invalid');
                }, 500)
            }
        },   
        doPostcodeSearch() {
            if (this.address.meta.isSearching) {
                return;
            }
            validate(
                this.address.postcode,
                this.form.getValidationRules(this.name + ".postcode")
            ).then(result => {
                if (result.valid) {
                    this.address.meta.isSearching = true;
                    pMinDelay(axios.post("/postcode/" + this.address.postcode), 1000)
                        .then(response => {
                            if (
                                response.status === 200 &&
                                response.data.status === "ok" &&
                                this.address.meta.isSearching
                            ) {
                                this.address.meta.addresses = response.data.result.addresses;
                                this.address.meta.showAddressResults = true;
                                window.amplitude.postcodeLookupEvent('success');
                                try {
                                    // setTimeout(() => {
                                    //     scrollToElementIfRequired(
                                    //         this.$refs.addressSelect.$el
                                    //     );
                                    // }, 750);
                                } catch (ex) {
                                    this.setEnterManually();
                                    window.amplitude.postcodeLookupEvent('Error');
                                }
                            }
                            this.address.meta.isSearching = false;
                        })
                        .catch(() => {
                            this.setEnterManually();
                            window.amplitude.postcodeLookupEvent('Error');
                        })
                        .finally(() => {
                            this.address.meta.isSearching = false;
                        });
                }
            });
        }
    },
    components: {
        "digi-input": DigiInput,
        "digi-select": DigiSelect
    },
    mounted() {
        if (!!this.$customer.thirdparty_prepop && !!this.address.postcode) {
            this.editAddress();
        }
    }
};
</script>